import React from "react";
import { Button, ButtonProps } from "@material-ui/core";
import { NavigationWrapper } from "./style";

export interface ExtendedButtonProps extends ButtonProps {
  "data-testid"?: string;
}
interface NavigationProps {
  cancelTitle?: string;
  disableNext?: boolean;
  nextTitle: string | JSX.Element;
  previousTitle?: string;
  extra?: React.ReactNode;
  onCancel?: () => void;
  onNext: () => void;
  onPrevious?: () => void;
  PrimaryButtonProps?: ExtendedButtonProps;
}

const Navigation = ({
  cancelTitle,
  disableNext,
  nextTitle,
  previousTitle,
  extra,
  onCancel,
  onNext,
  onPrevious,
  PrimaryButtonProps = {},
}: NavigationProps) => (
  <NavigationWrapper>
    {extra && <div className="extra">{extra}</div>}

    {onCancel && <Button onClick={onCancel}>{cancelTitle}</Button>}
    <div className="actions">
      {onPrevious && (
        <Button color="primary" className="previous" variant="outlined" onClick={onPrevious}>
          {previousTitle}
        </Button>
      )}

      <Button
        className="nextButton"
        color="primary"
        variant="contained"
        disabled={disableNext}
        style={{ opacity: disableNext ? 0.5 : 1, backgroundColor: "#399ebf", color: "#fff" }}
        onClick={onNext}
        {...PrimaryButtonProps}
      >
        {nextTitle}
      </Button>
    </div>
  </NavigationWrapper>
);

export default Navigation;
